export const options_messagePreview_Off = "gc8agc";
export const options_messagePreview_oneLine = "ZVjTEd";
export const options_messagePreview_twoLines = "KIRDab";
export const options_messagePreview_inline = "aXEnDb";
export const options_messageList_previewLabel = "bjoR6c";
export default {options_messagePreview_Off,options_messagePreview_oneLine,options_messagePreview_twoLines,options_messagePreview_inline,options_messageList_previewLabel};